import {
  REACT_QUERY_CONFIG,
  REACT_QUERY_DEVTOOL_INITIAL_STATE,
} from '@/config/settings'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { ReactNode } from 'react'

export const queryClient = new QueryClient(REACT_QUERY_CONFIG)

// Allow automated capture (manual screenshots / demo video) to suppress the
// floating Devtools widget via VITE_DISABLE_DEVTOOLS, so it never overlaps the UI
// or intercepts clicks. Unset in normal dev, so behaviour there is unchanged.
const DEVTOOLS_DISABLED = import.meta.env.VITE_DISABLE_DEVTOOLS === 'true'

export function ReactQueryProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {!DEVTOOLS_DISABLED && (
        <ReactQueryDevtools initialIsOpen={REACT_QUERY_DEVTOOL_INITIAL_STATE} />
      )}
    </QueryClientProvider>
  )
}
